/* Adtrip 10.2026: pasek celów koszyka (darmowa dostawa + prezent) i automatyczny prezent.
   Prezent = pierwszy produkt z kolekcji ustawionej w motywie; cena 0 zł nadaje rabat automatyczny Shopify (Buy X get Y).
   Motyw dodaje prezent z właściwością _gift=true, gdy wartość koszyka bez prezentu (po rabatach) >= próg; usuwa, gdy spadnie poniżej. */
(function () {
  if (window.AdtripCart) return;

  const settings = () => window.FoxThemeSettings || { routes: { cart: '/cart', cart_add_url: '/cart/add', cart_change_url: '/cart/change', cart_update_url: '/cart/update' } };
  const jsonHeaders = { 'Content-Type': 'application/json', Accept: 'application/json' };

  function money(cents) {
    try { if (typeof formatMoney === 'function') return formatMoney(cents, settings().money_format); } catch (e) {}
    return (cents / 100).toFixed(2).replace('.', ',') + ' zł';
  }
  const isGiftLine = (item) => !!(item && item.properties && item.properties._gift === 'true');

  function baseTotal(cart) {
    let total = 0;
    (cart.items || []).forEach((i) => { if (!isGiftLine(i)) total += Number(i.final_line_price || 0); });
    // Ajax API: [{ amount, discount_application: { total_allocated_amount } }] – kwota siedzi na zewnętrznym obiekcie
    (cart.cart_level_discount_applications || []).forEach((d) => {
      const amt = d.amount != null ? d.amount : ((d.discount_application || {}).total_allocated_amount || d.total_allocated_amount || 0);
      total -= Number(amt || 0);
    });
    return Math.max(0, total);
  }

  async function fetchCart() {
    const r = await fetch(`${settings().routes.cart}.js`, { headers: { Accept: 'application/json' } });
    return r.json();
  }

  function sectionsRequest() {
    const list = ['cart-drawer'];
    const pageItems = document.getElementById('main-cart-items');
    const pageFooter = document.getElementById('main-cart-footer');
    if (pageItems && pageItems.dataset.id) {
      list.push(pageItems.dataset.id, 'cart-live-region-text');
      if (pageFooter && pageFooter.dataset.id) list.push(pageFooter.dataset.id);
    }
    return { sections: list.join(','), sections_url: window.location.pathname };
  }

  async function postCart(url, body) {
    const r = await fetch(url, { method: 'POST', headers: jsonHeaders, body: JSON.stringify(body) });
    return r.json();
  }

  // Pełny stan koszyka + wyrenderowane sekcje (do podmiany HTML bez przeładowania)
  function refreshState() {
    return postCart(`${settings().routes.cart_update_url}.js`, Object.assign({}, sectionsRequest()));
  }

  function renderAll(state) {
    if (!state || !Array.isArray(state.items)) return;
    const page = document.querySelector('cart-items');
    if (page && state.sections && document.getElementById('main-cart-items') && typeof page.renderContents === 'function') {
      try { page.renderContents(state); } catch (e) { console.warn('[adtrip cart] render page', e); }
    }
    const drawerItems = document.querySelector('cart-drawer-items');
    if (drawerItems && state.sections && state.sections['cart-drawer'] && typeof drawerItems.renderContents === 'function') {
      try { drawerItems.renderContents(state); } catch (e) { console.warn('[adtrip cart] render drawer', e); }
    }
    const drawer = document.querySelector('cart-drawer');
    if (drawer) drawer.classList.toggle('is-empty', state.item_count === 0);
    const footer = document.getElementById('main-cart-footer');
    if (footer) footer.classList.toggle('is-empty', state.item_count === 0);
    if (window.FoxThemeEvents) window.FoxThemeEvents.emit('ON_CART_UPDATED', state);
  }

  const Gift = {
    cfg: null, busy: false, inited: false,
    init(el) {
      if (this.inited) return;
      this.inited = true;
      this.cfg = {
        enabled: el.dataset.giftEnabled === 'true',
        variant: String(el.dataset.giftVariant || ''),
        limit: Number(el.dataset.giftLimit || 0)
      };
      if (!this.cfg.enabled || !this.cfg.variant || !this.cfg.limit) return;
      if (window.FoxThemeEvents) {
        window.FoxThemeEvents.subscribe('ON_CART_UPDATED', (state) => this.check(state));
        window.FoxThemeEvents.subscribe('ON_ITEM_ADDED', () => this.check());
      }
      this.check();
    },
    // blokada ponownego dodawania, gdy rabat prezentu nie zadziałał – per wariant + zestaw kodów w koszyku (zmiana kodów = nowa próba)
    failKey(cart) {
      const codes = ((cart && cart.discount_codes) || []).map((c) => String(c.code).toUpperCase()).sort().join('+');
      return 'adtrip_gift_fail_' + this.cfg.variant + '_' + codes;
    },
    failed(cart) {
      try { const t = Number(sessionStorage.getItem(this.failKey(cart)) || 0); return !!t && Date.now() - t < 15 * 60 * 1000; } catch (e) { return false; }
    },
    markFailed(cart) { try { sessionStorage.setItem(this.failKey(cart), String(Date.now())); } catch (e) {} },
    async check(state, second) {
      if (this.busy || !this.cfg) return;
      this.busy = true;
      let changed = null;
      try {
        const cart = state && Array.isArray(state.items) ? state : await fetchCart();
        const gifts = cart.items.filter(isGiftLine);
        const others = cart.items.length - gifts.length;
        const want = others > 0 && baseTotal(cart) >= this.cfg.limit && !this.failed(cart);
        if (gifts.length) {
          const g = gifts[0];
          const stale = gifts.length > 1 || g.quantity !== 1 || String(g.variant_id) !== this.cfg.variant;
          const unpaid = Number(g.final_line_price || 0) > 0; // rabat automatyczny nie zadziałał – nie dopuszczamy do płatnej linii
          if (!want || stale || unpaid) {
            if (want && unpaid && !stale) this.markFailed(cart);
            changed = await this.removeAll(gifts);
            if (want && stale && !this.failed(cart)) changed = await this.add();
          }
        } else if (want) {
          changed = await this.add();
        }
      } catch (e) {
        console.warn('[adtrip gift]', e);
      } finally {
        this.busy = false;
      }
      if (changed) {
        renderAll(changed);
        if (!second) this.check(changed, true);
      }
    },
    async add() {
      const res = await postCart(`${settings().routes.cart_add_url}.js`, {
        items: [{ id: Number(this.cfg.variant), quantity: 1, properties: { _gift: 'true' } }]
      });
      if (res && res.status && res.status >= 400) { this.markFailed(null); return null; }
      return refreshState();
    },
    async removeAll(gifts) {
      for (const g of gifts) {
        await postCart(`${settings().routes.cart_change_url}.js`, { id: g.key, quantity: 0 });
      }
      return refreshState();
    }
  };

  class FCartGoal extends HTMLElement {
    connectedCallback() {
      let goals = [];
      try { goals = JSON.parse((this.querySelector('[data-goals]') || {}).textContent || '[]'); } catch (e) {}
      this.goals = goals.filter((g) => g && g.limit > 0).sort((a, b) => a.limit - b.limit);
      this.max = this.goals.length ? this.goals[this.goals.length - 1].limit : 1;
      this.msgEl = this.querySelector('[data-goal-message]');
      this.enableConfetti = this.dataset.enableConfetti === 'true';
      this.confettiShown = false;
      this.update(Number(this.dataset.baseTotal || 0), Number(this.dataset.itemCount || 0), this.dataset.hasGift === 'true');
      if (window.FoxThemeEvents) {
        this.unsub1 = window.FoxThemeEvents.subscribe('ON_CART_UPDATED', (state) => {
          if (state && Array.isArray(state.items)) this.update(baseTotal(state), state.item_count, state.items.some(isGiftLine));
        });
        this.unsub2 = window.FoxThemeEvents.subscribe('ON_ITEM_ADDED', async () => {
          const c = await fetchCart();
          this.update(baseTotal(c), c.item_count, c.items.some(isGiftLine));
        });
      }
      if (this.dataset.giftEnabled === 'true') Gift.init(this);
    }
    disconnectedCallback() {
      if (this.unsub1) this.unsub1();
      if (this.unsub2) this.unsub2();
    }
    update(base, count, hasGift) {
      this.classList.toggle('hidden', !(count > 0));
      const teaser = this.querySelector('[data-gift-teaser]');
      if (teaser) teaser.hidden = !!hasGift;
      const pct = Math.min(100, Math.round((base / this.max) * 1000) / 10);
      this.style.setProperty('--progress', `${pct}%`);
      this.goals.forEach((g) => {
        const m = this.querySelector(`[data-marker="${g.key}"]`);
        if (m) m.classList.toggle('is-done', base >= g.limit);
      });
      const next = this.goals.find((g) => base < g.limit);
      if (!this.msgEl) return;
      if (next) {
        this.msgEl.innerHTML = String(next.msg || '').replace('{{amount}}', `<strong>${money(next.limit - base)}</strong>`);
        this.classList.remove('f-cartgoal--done');
        this.confettiShown = false;
      } else {
        const gift = this.goals.find((g) => g.key === 'gift');
        const ship = this.goals.find((g) => g.key === 'ship');
        const done = (gift && hasGift) ? gift.done : (ship ? ship.done : (gift ? gift.done : ''));
        this.msgEl.innerHTML = done;
        this.classList.add('f-cartgoal--done');
        if (this.enableConfetti && !this.confettiShown && window.FoxTheme && window.FoxTheme.Confetti) {
          this.confettiShown = true;
          const target = this.closest('.f-cart-drawer__inner') || document.body;
          setTimeout(() => { try { new window.FoxTheme.Confetti(target); } catch (e) {} }, 600);
        }
      }
    }
  }
  if (!customElements.get('f-cart-goal')) customElements.define('f-cart-goal', FCartGoal);

  window.AdtripCart = { money, baseTotal, fetchCart, sectionsRequest, postCart, refreshState, renderAll, isGiftLine, Gift };
})();
